import { clearEmptyMarkup } from '@/common/helpers/clearEmptyMarkup/clearEmptyMarkup';

export interface ForwardForm {
  title: string;
  description: string;
  // url is used only for url type
  url: string;
  previewUrl: string;
}

export function createEmptyForm(): ForwardForm {
  return {
    title: '',
    description: '',
    url: '',
    previewUrl: '',
  };
}

interface CleanUpFormOptions {
  isUrl?: boolean;
  withPreview?: boolean;
  // When the form is read-only we cannot edit title/description, so we send null
  // instead of empty strings and let the backend fill in the proper values.
  readOnly?: boolean;
}

export function cleanUpForm(
  form: ForwardForm,
  { isUrl = false, withPreview = false, readOnly = false }: CleanUpFormOptions = {},
): { title: Nullable<string>; description: Nullable<string>; url?: string; preview?: Nullable<string> } {
  const res: { title: Nullable<string>; description: Nullable<string>; url?: string; preview?: Nullable<string> } = {
    title: readOnly ? null : form.title.trim(),
    description: readOnly ? null : clearEmptyMarkup(form.description),
  };

  if (isUrl) {
    res.url = form.url.trim();
  }

  if (withPreview && !readOnly) {
    res.preview = form.previewUrl.trim() || null;
  }

  return res;
}
